import React from 'react';

export const WaterTemperatureIcon = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 38 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 28.352C3.555 29.784 5.222 30.501 7.002 30.501C9.672 30.501 10.311 28.351 12.986 28.351C15.662 28.351 16.716 30.501 18.819 30.501C20.921 30.501 22.538 28.351 24.634 28.351C26.73 28.351 27.674 30.693 30.357 30.669C32.145 30.654 33.911 29.833 35.656 28.208"
      stroke="#0259FE"
      strokeWidth="1.5"
    />
    <mask
      id="waterTemperatureIconMask"
      type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="20"
      width="38"
      height="8"
    >
      <path
        d="M15.913 27.001L0 27V21H11.15C11.578 23.73 13.425 25.99 15.913 27.001ZM38 21V27L21.775 27.001C24.263 25.99 26.11 23.73 26.538 20.999L38 21Z"
        fill="white"
      />
    </mask>
    <g mask="url(#waterTemperatureIconMask)">
      <path
        d="M2 23.814C3.555 25.246 5.222 25.961 7.002 25.961C9.672 25.961 10.311 23.813 12.986 23.813C15.662 23.813 16.716 25.961 18.819 25.961C20.921 25.961 22.538 23.813 24.634 23.813C26.73 23.813 27.674 26.153 30.357 26.13C32.145 26.114 33.911 25.294 35.656 23.668"
        stroke="#0259FE"
        strokeWidth="1.5"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.931 0C20.4 0 21.59 1.19 21.59 2.658V13.814C23.847 14.854 25.414 17.136 25.414 19.784C25.414 23.411 22.473 26.352 18.845 26.352C15.217 26.352 12.277 23.411 12.277 19.783C12.277 17.136 13.843 14.854 16.1 13.814V2.658C16.099 1.19 17.289 0 18.757 0H18.931Z"
      fill="#EBEBEB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.122 3.509V15.099C22.184 15.659 23.699 17.544 23.699 19.783C23.699 22.465 21.525 24.638 18.844 24.638C16.163 24.638 13.989 22.465 13.989 19.783C13.989 17.544 15.504 15.659 17.566 15.098V3.51H20.122V3.509Z"
      fill="#FF504D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.608 7.20599H21.248V8.20599H16.608V7.20599ZM16.608 11.623H21.248V12.623H16.608V11.623Z"
      fill="#EBEBEB"
    />
  </svg>
);
